import getAuthorizationHeader from "./get-authorization-header";

export default async function getHeaders(customHeaders) {
  const headers = await getAuthorizationHeader();
  return { ...headers, ...customHeaders };
}
